"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Option = _interopRequireDefault(require("../../controls/Option"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DefaultOption = function DefaultOption(optionProps) {
  var id = optionProps.id,
      type = optionProps.type,
      name = optionProps.name,
      checked = optionProps.checked,
      _value = optionProps.value,
      disabled = optionProps.disabled,
      handleOptionChange = optionProps.handleOptionChange,
      attrs = _objectWithoutProperties(optionProps, ["id", "type", "name", "checked", "value", "disabled", "handleOptionChange"]);

  return /*#__PURE__*/_react.default.createElement(_Option.default, _extends({
    key: id,
    tag: "li",
    type: type,
    id: id,
    name: name,
    checked: checked,
    disabled: disabled,
    onChange: handleOptionChange
  }, attrs));
};

var _default = DefaultOption;
exports.default = _default;
//# sourceMappingURL=DefaultOption.js.map